import { Box, styled } from '@mui/material';

export const ArchivedWidgetsListRoot = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  marginTop: '8px',
}));
